import { create } from 'zustand'

import {
  getPeoplePreviewDetails,
  getDetailedSummary,
  editDetailedSummary,
  getCollaborators,
  getCollaboratorsList,
  getCollaboratorDetails,
  getCollaboratorsTotal,
  getCollaboratorsIndicators,
  createRescissionSimulation,
  createAdmissionSimulation,
  getSimulations,
  deleteSimulation,
  editRescissionSimulation,
  editAdmissionSimulation,
  generalAdjustPeople,
  releasePreviewPeople,
  reversePreviewPeople
} from './provider'

import type {
  PeopleBigNumbersDataProps,
  WeeklyPreviewResponseProps,
  DetailedSummaryResponseProps,
  CollaboratorsDataProps,
  CollaboratorsListResponseProps,
  CollaboratorDetailsResponseProps,
  CollaboratorsTotalResponseProps,
  CollaboratorsIndicatorsResponseProps,
  UsePeopleProps,
  SimulationListItemProps
} from './types'

export const usePeople = create<UsePeopleProps>((set) => ({
  bigNumbersData: null,
  setBigNumbersData: (value: PeopleBigNumbersDataProps | null) => set({ bigNumbersData: value }),
  isBigNumbersLoading: false,
  setIsBigNumbersLoading: (value: boolean) => set({ isBigNumbersLoading: value }),

  weeklyPreviewData: null,
  setWeeklyPreviewData: (value: WeeklyPreviewResponseProps | null) => set({ weeklyPreviewData: value }),
  isWeeklyPreviewLoading: false,
  setIsWeeklyPreviewLoading: (value: boolean) => set({ isWeeklyPreviewLoading: value }),

  detailedSummaryData: null,
  setDetailedSummaryData: (value: DetailedSummaryResponseProps | null) => set({ detailedSummaryData: value }),
  isDetailedSummaryLoading: false,
  setIsDetailedSummaryLoading: (value: boolean) => set({ isDetailedSummaryLoading: value }),

  collaboratorsData: null,
  setCollaboratorsData: (value: CollaboratorsDataProps | null) => set({ collaboratorsData: value }),
  isCollaboratorsLoading: false,
  setIsCollaboratorsLoading: (value: boolean) => set({ isCollaboratorsLoading: value }),

  collaboratorsListData: null,
  setCollaboratorsListData: (value: CollaboratorsListResponseProps | null) => set({ collaboratorsListData: value }),
  isCollaboratorsListLoading: false,
  setIsCollaboratorsListLoading: (value: boolean) => set({ isCollaboratorsListLoading: value }),

  collaboratorDetailsData: null,
  setCollaboratorDetailsData: (value: CollaboratorDetailsResponseProps | null) =>
    set({ collaboratorDetailsData: value }),
  isCollaboratorDetailsLoading: false,
  setIsCollaboratorDetailsLoading: (value: boolean) => set({ isCollaboratorDetailsLoading: value }),

  collaboratorsTotalData: null,
  setCollaboratorsTotalData: (value: CollaboratorsTotalResponseProps | null) => set({ collaboratorsTotalData: value }),
  isCollaboratorsTotalLoading: false,
  setIsCollaboratorsTotalLoading: (value: boolean) => set({ isCollaboratorsTotalLoading: value }),

  collaboratorsIndicatorsData: null,
  setCollaboratorsIndicatorsData: (value: CollaboratorsIndicatorsResponseProps | null) =>
    set({ collaboratorsIndicatorsData: value }),
  isCollaboratorsIndicatorsLoading: false,
  setIsCollaboratorsIndicatorsLoading: (value: boolean) => set({ isCollaboratorsIndicatorsLoading: value }),

  simulationsData: null,
  setSimulationsData: (value: SimulationListItemProps[] | null) => set({ simulationsData: value }),
  isSimulationsLoading: false,
  setIsSimulationsLoading: (value: boolean) => set({ isSimulationsLoading: value }),
  simulationsCanEdit: true,
  setSimulationsCanEdit: (value: boolean) => set({ simulationsCanEdit: value }),

  isGeneralAdjustLoading: false,
  setIsGeneralAdjustLoading: (value: boolean) => set({ isGeneralAdjustLoading: value }),

  isReleasePreviewPeopleLoading: false,
  setIsReleasePreviewPeopleLoading: (value: boolean) => set({ isReleasePreviewPeopleLoading: value }),

  isReversePreviewPeopleLoading: false,
  setIsReversePreviewPeopleLoading: (value: boolean) => set({ isReversePreviewPeopleLoading: value }),

  isRescissionSimulationLoading: false,
  setIsRescissionSimulationLoading: (value: boolean) => set({ isRescissionSimulationLoading: value }),

  getPeoplePreviewDetails,
  getDetailedSummary,
  editDetailedSummary,
  getCollaborators,
  getCollaboratorsList,
  getCollaboratorDetails,
  getCollaboratorsTotal,
  getCollaboratorsIndicators,
  createRescissionSimulation,
  createAdmissionSimulation,
  getSimulations,
  deleteSimulation,
  editRescissionSimulation,
  editAdmissionSimulation,
  generalAdjustPeople,
  releasePreviewPeople,
  reversePreviewPeople
}))
